import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class potentialInstructorsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = "/api/potentialInstructors";
    return this.CommonAPIService.getCall(url, "", router);
  }

  getInstructorById(userId, router) {
    const url = `/api/potentialInstructors/${userId}`;
    return this.CommonAPIService.getCall(url, "", router);
  }

  create(params, router) {
    const url = "/api/potentialInstructors";
    return this.CommonAPIService.postCall(url, params, router);
  }

  delete(userId, router) {
    const url = `/api/potentialInstructors/${userId}`;
    return this.CommonAPIService.deleteCall(url, "", router);
  }

  sendApplicationEmail(userId, params, router) {
    const url = `/api/potentialInstructors/applicationEmail/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  sendOrientationEmail(userId, params, router) {
    const url = `/api/potentialInstructors/orientationEmail/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  convertToActive(userId, router) {
    const url = `/api/potentialInstructors/convertToActiveInstructor/${userId}`;
    return this.CommonAPIService.putCall(url, "", router);
  }

  update(userId, params, router) {
    const url = `/api/potentialInstructors/${userId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }
}
export default potentialInstructorsAPIService;
